import { Invoice } from '../../../types';

export function BoldInvoicePreview({ invoice, company }: { invoice: Invoice, company: any, workspace: any }) {
  const brandColor = company.primaryColor || '#B91C1C';
  return (
    <div className="bg-white mx-auto shadow-lg rounded-lg overflow-hidden print:shadow-none" style={{ width: '210mm', minHeight: '297mm', fontFamily: 'Inter, system-ui, sans-serif' }}>
      {/* Header */}
      <div className="w-full" style={{ backgroundColor: brandColor, height: 70 }}>
        <div className="flex items-center h-full px-8">
          <span className="text-white text-3xl font-bold mx-auto">INVOICE</span>
        </div>
      </div>
      <div className="px-8 pt-8">
        <div className="text-2xl font-bold" style={{ color: brandColor }}>#{invoice.invoiceNumber}</div>
        <div className="text-base font-bold mt-2">{company.companyName}</div>
        <div className="text-xs text-gray-700" style={{ whiteSpace: 'pre-line' }}>{company.address}</div>
        <div className="text-xs text-gray-700">Phone: {company.phone}</div>
        <div className="text-xs text-gray-700">{company.email}</div>
      </div>
      <div className="px-8 pt-8">
        <div className="font-bold text-xs">Bill To:</div>
        <div className="text-xs">{invoice.client.name}</div>
        <div className="text-xs">{invoice.client.address}</div>
        <div className="text-xs">{invoice.client.phone}</div>
        <div className="text-xs">{invoice.client.email}</div>
      </div>
      <div className="px-8 pt-8">
        <div className="grid grid-cols-12 gap-2 text-xs font-bold text-white" style={{ backgroundColor: brandColor }}>
          <div className="col-span-6">DESCRIPTION</div>
          <div className="col-span-2 text-center">RATE</div>
          <div className="col-span-2 text-center">QTY</div>
          <div className="col-span-2 text-right">AMOUNT</div>
        </div>
        {invoice.items.map((item, idx) => (
          <div key={item.id} className={`grid grid-cols-12 gap-2 text-xs ${idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
            <div className="col-span-6">{item.description}</div>
            <div className="col-span-2 text-center">{item.rate}</div>
            <div className="col-span-2 text-center">{item.quantity}</div>
            <div className="col-span-2 text-right">{item.amount}</div>
          </div>
        ))}
      </div>
      <div className="px-8 pt-8 flex justify-end">
        <div className="w-80">
          <div className="flex justify-between text-lg font-bold" style={{ color: brandColor }}><span>Total:</span><span>{invoice.total}</span></div>
        </div>
      </div>
      <div className="text-center text-gray-500 text-sm mt-12">Thank you!</div>
      {/* Signature */}
      {invoice.signature && (
        <div className="mt-10 text-center border-t-2 pt-6 border-gray-400">
          <div className="text-xs text-gray-500 mb-1">Authorized Signature</div>
          {invoice.signature.startsWith('http') ? (
            <img src={invoice.signature} alt="Signature" className="mx-auto h-12 object-contain" />
          ) : (
            <div className="italic text-lg font-signature text-gray-700" style={{ fontFamily: 'cursive, serif' }}>{invoice.signature}</div>
          )}
        </div>
      )}
    </div>
  );
} 